import { CodeNode } from "@lexical/code";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { MarkNode } from "@lexical/mark";
import { OverflowNode } from "@lexical/overflow";
import { HorizontalRuleNode } from "@lexical/react/LexicalHorizontalRuleNode";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { $createParagraphNode, $createTextNode, $getRoot, ParagraphNode } from "lexical";

import { EditorFeature } from "..";
import { HashtagNode } from "../plugins/HashtagSuggestionPlugin/HashtagNode";

// Nodes represent the different types of content that can be added to the editor.
// They are the building blocks of the editor, and are used to represent both the
// editor's internal state and the external data format.
// Learn more here: https://lexical.dev/docs/concepts/nodes

const EDITOR_NODES = [
	HeadingNode,
	HorizontalRuleNode,
	ParagraphNode,
	LinkNode,
	CodeNode,
	ListNode,
	ListItemNode,
	QuoteNode,
	MarkNode,
	HashtagNode,
	AutoLinkNode,
	OverflowNode,
];

/**
 * Returns the list of nodes that should be used in the editor based on the
 * provided disabled features.
 */
export const getEditorNodes = (disabledFeatures?: EditorFeature[]) => {
	return EDITOR_NODES.filter((node) => {
		if (node === HeadingNode && disabledFeatures?.includes("heading")) {
			return false;
		}
		if (node === QuoteNode && disabledFeatures?.includes("quote")) {
			return false;
		}
		if (node === LinkNode && disabledFeatures?.includes("link")) {
			return false;
		}
		if (node === ListNode && disabledFeatures?.includes("list")) {
			return false;
		}
		if (node === MarkNode && disabledFeatures?.includes("bold")) {
			return false;
		}
		if (node === MarkNode && disabledFeatures?.includes("italic")) {
			return false;
		}
		if (node === MarkNode && disabledFeatures?.includes("underline")) {
			return false;
		}
		if (node === MarkNode && disabledFeatures?.includes("strikethrough")) {
			return false;
		}
		return true;
	});
};

// default empty state to prevent a bug on pasting
export function emptyState() {
	const root = $getRoot();
	if (root.getFirstChild() === null) {
		const paragraph = $createParagraphNode();
		paragraph.append($createTextNode(""));
		root.append(paragraph);
	}
}
